import { AfterViewInit, Component, inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import {
  IonButton,
  IonButtons,
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonIcon,
  IonInput,
  IonItem,
  IonLabel,
  IonRow,
  IonTitle,
  IonToolbar,
  ModalController,
} from '@ionic/angular/standalone';
import { SpinnerLoadingComponent } from '@okcargo-apps/layout-ionic';
import { IStopAddress } from '@okcargo-apps/shared-domain';
import { IAddressBookEntry } from '@okcargo-apps/shared-domain-ionic';
import { AddressbookService } from '../addressbook.service';

@Component({
  selector: 'lib-search-addressbook-modal',
  templateUrl: './search-addressbook-modal.component.html',
  styleUrls: ['./search-addressbook-modal.component.scss'],
  imports: [
    ReactiveFormsModule,
    IonLabel,
    IonItem,
    IonContent,
    IonCol,
    IonRow,
    IonGrid,
    IonInput,
    IonTitle,
    IonIcon,
    IonButton,
    IonToolbar,
    IonButtons,
    IonHeader,
    IonInput,
    SpinnerLoadingComponent,
  ],
})
export class SearchAddressbookModalComponent implements OnInit, AfterViewInit {
  private readonly fb = inject(FormBuilder);
  private readonly modalCtrl = inject(ModalController);
  private readonly addressbookService = inject(AddressbookService);

  public isLoading = this.addressbookService.loading;
  public addressbookEntries = this.addressbookService.adresses;

  @ViewChild('searchInput')
  searchInput!: IonInput;

  public readonly formAddressEdit = this.fb.group({
    searchTerm: ['', Validators.minLength(2)],
  });

  // constructor() {}

  ngOnInit(): void {
    this.addressbookService.clearAddresses();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (this.searchInput) {
        this.searchInput.setFocus();
      }
    }, 100);
  }

  public handleChangeTerm(event: any): void {
    const searchTerm = event.target.value?.trim();
    this.addressbookService.searchAddresses(searchTerm);
  }

  public async handleSelectAddress(addressbookEntry: IAddressBookEntry): Promise<boolean> {
    if (addressbookEntry.placeId) {
      const company = addressbookEntry.textToDisplay.split(',')[0].trim();
      const newAddressFound = await this.addressbookService.findAddressByPlaceId(addressbookEntry.placeId);
      const newAddress = { ...newAddressFound, company };
      const dismissResult = this.modalCtrl.dismiss(newAddress as IStopAddress, 'confirm');
      return dismissResult;
    }

    if (addressbookEntry.address) {
      const dismissResult = this.modalCtrl.dismiss(addressbookEntry.address, 'confirm');
      return dismissResult;
    }

    return false;
  }

  public async closeModalWithCancel(): Promise<boolean> {
    return this.modalCtrl.dismiss(null, 'cancel');
  }
}
